import { render, staticRenderFns } from "./TipsPhone.vue?vue&type=template&id=039c1e59&"
import script from "./TipsPhone.vue?vue&type=script&lang=js&"
export * from "./TipsPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports